import { Elevations as PaperElevations } from '@/components/Paper/Paper.constants'

export const GROUP_NAME = 'menu'

export enum Orientations {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

export const DEFAULT_ORIENTATION = Orientations.Vertical

export const DEFAULT_ELEVATION = PaperElevations.Elevated
export const DEFAULT_SUB_MENU_ELEVATION = PaperElevations.Bordered
